module.exports = __webpack_public_path__ + "static/media/Beauty.aa34579d.png";